import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const MatchReportAPI = {
	common: async (matchId, playerId) =>
		(
			await api.request({
				method: "GET",
				url: apiUrl + "/GoalkeepersMatchReports/common",
				useAuthInterceptor: USE_AUTH_INTERCEPTOR,
				params: {matchId, playerId},
			})
		).data,
	list: async (data) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/GoalkeepersMatchReports",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params: data,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/GoalkeepersMatchReports",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/GoalkeepersMatchReports/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/GoalkeepersMatchReports/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/GoalkeepersMatchReports/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
};
